import React, { useState } from 'react'
import Toast from '@ingka/toast'
import { useTranslation } from 'react-i18next'
import useDelay from 'hooks/useDelay'

const RotatePhoneToast = () => {
    const { t } = useTranslation()
    const [isOpen, setIsOpen] = useState(false)
    useDelay(() => setIsOpen(true), 500)

    const message = t('toasts.rotate phone')
    return <Toast text={message} isOpen={isOpen} onCloseRequest={() => setIsOpen(false)} onTransitionEnd={() => {}} />
}

export default RotatePhoneToast
